module.exports = __webpack_public_path__ + "static/media/IMAGE_4-BEE_TRUCK_(Peter_Nelson)_desktop.eb3e618c.jpg";